import { useSEO } from '@/hooks/useSEO';

export default function Terms() {
  useSEO(
    'Terms of Service | Earning Calculators.Com',
    'Read the Terms of Service for Earning Calculators.Com.'
  );

  const lastUpdated = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-headline text-4xl md:text-5xl font-bold tracking-tighter mb-6 text-center">
          Terms of Service
        </h1>
        <div className="prose prose-lg mx-auto text-muted-foreground">
          <p><strong>Last Updated: {lastUpdated}</strong></p>
          <p>
            By accessing and using Earning Calculators.Com (the "Service"), you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Use of Service</h2>
          <p>
            The Service and its tools are provided for informational and estimation purposes only. The calculations are not financial advice. You are responsible for your own financial decisions.
          </p>
          <p>
            You agree not to use the service for any unlawful purpose or to solicit others to perform or participate in any unlawful acts.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, that the Service will be uninterrupted, timely, secure, or error-free. The results from the calculators are estimates and we do not guarantee their accuracy.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Limitation of Liability</h2>
          <p>
            In no event shall Earning Calculators.Com, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Changes</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
          </p>
        </div>
      </div>
    </div>
  );
}